import { Col, Row, Spin } from 'antd';
import { CardTheme } from '../../../components/card';
import { StyledContainer } from '../../../components/container/styles';
import { TextLarge } from '../../../components/text';
import { RenderForm } from '../../../components/forms';
import { useGetRegAddList } from './hooks/useGetRegAddList';
import { FORM_CUSTOMER_DATA, FORM_PRODUCT_DATA } from './form';
import { ButtonTheme } from '../../../components/buttons';
import { ContainerButton } from '../../../styles/global-style';
import React from 'react';

export const RegistrationAdd = () => {
  const {
    control,
    getValues,
    setValue,
    onEnterTele,
    isCallingTele,
    onEnterBarcode,
    isCallingBarcode,
    mobileBrandList,
    channelBuyList,
    onSubmit,
    handleSubmit,
    isOnAddLoading,
    isSubmitting,
    onEnterWarrantyCode,
    isCallingWarrantyCode,
    dataBarcode,
  } = useGetRegAddList();

  return (
    <Spin spinning={isCallingTele || isCallingBarcode || isOnAddLoading || isCallingWarrantyCode}>
      <StyledContainer>
        <TextLarge text="ลงทะเบียนสินค้า" />
        <Row gutter={16}>
          <Col span={14}>
            <CardTheme>
              <TextLarge text="ลูกค้าลงทะเบียนรับประกัน" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_CUSTOMER_DATA({ onEnter: onEnterTele })}
              />
            </CardTheme>
          </Col>
          <Col span={10}>
            <CardTheme>
              <TextLarge text="สินค้าลงทะเบียนรับประกัน" />
              <RenderForm
                control={control}
                setValue={setValue}
                getValues={getValues}
                forms={FORM_PRODUCT_DATA({
                  onEnter: onEnterBarcode,
                  mobileBrandList,
                  channelBuyList,
                  onEnterWarrantyCode,
                  isWarrantyCodeEnabled: !!dataBarcode,
                  isWarrantyCodeRequired: dataBarcode?.item?.isWarrantyNumberRequired,
                })}
              />
            </CardTheme>
          </Col>
        </Row>
        <ContainerButton right>
          <ButtonTheme
            useFor="SUBMIT"
            style={{ marginTop: '2%' }}
            onClick={handleSubmit(onSubmit)}
            disabled={isSubmitting}
          />
        </ContainerButton>
      </StyledContainer>
    </Spin>
  );
};
